const MOUSEDOWN = 'mousedown';

export default MOUSEDOWN;
